export function IdentitiesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.1626 7.80243C15.1626 8.07857 14.9387 8.30243 14.6626 8.30243C14.3865 8.30243 14.1626 8.07857 14.1626 7.80243C14.1626 7.52628 14.3865 7.30243 14.6626 7.30243C14.9387 7.30243 15.1626 7.52628 15.1626 7.80243Z"
        fill="#F3F4F7"
      />
      <path
        d="M16.7293 8.30243C17.0055 8.30243 17.2293 8.07857 17.2293 7.80243C17.2293 7.52628 17.0055 7.30243 16.7293 7.30243C16.4532 7.30243 16.2293 7.52628 16.2293 7.80243C16.2293 8.07857 16.4532 8.30243 16.7293 8.30243Z"
        fill="#F3F4F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6737 4.59741C15.9498 4.59741 16.1737 4.82127 16.1737 5.09741V5.93075H16.7838C17.7963 5.93075 18.6172 6.75156 18.6172 7.76408V9.11771C18.6172 10.1302 17.7963 10.951 16.7838 10.951H16.1737V11.5588H18.5293C19.9101 11.5588 21.0293 12.678 21.0293 14.0588V18.9025C21.0293 19.1787 20.8055 19.4025 20.5293 19.4025H14.8626C14.5865 19.4025 14.3626 19.1787 14.3626 18.9025C14.3626 18.6264 14.5865 18.4025 14.8626 18.4025H20.0293V14.0588C20.0293 13.2303 19.3578 12.5588 18.5293 12.5588H13.5293C13.2532 12.5588 13.0293 12.3349 13.0293 12.0588C13.0293 11.7826 13.2532 11.5588 13.5293 11.5588H15.1737V10.951H14.6261C13.6136 10.951 12.7928 10.1302 12.7928 9.11771V7.76408C12.7928 6.75156 13.6136 5.93075 14.6261 5.93075H15.1737V5.09741C15.1737 4.82127 15.3975 4.59741 15.6737 4.59741ZM15.6759 9.95104L15.6737 9.95103L15.6714 9.95104H14.6261C14.1659 9.95104 13.7928 9.57794 13.7928 9.11771V7.76408C13.7928 7.30384 14.1659 6.93075 14.6261 6.93075H16.7838C17.2441 6.93075 17.6172 7.30384 17.6172 7.76408V9.11771C17.6172 9.57794 17.2441 9.95104 16.7838 9.95104H15.6759Z"
        fill="#F3F4F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.41709 5.22596C6.78039 5.22596 5.45359 6.55276 5.45359 8.18946C5.45359 9.82616 6.78039 11.153 8.41709 11.153C10.0538 11.153 11.3806 9.82616 11.3806 8.18946C11.3806 6.55276 10.0538 5.22596 8.41709 5.22596ZM6.45359 8.18946C6.45359 7.10505 7.33268 6.22596 8.41709 6.22596C9.5015 6.22596 10.3806 7.10505 10.3806 8.18946C10.3806 9.27387 9.5015 10.153 8.41709 10.153C7.33268 10.153 6.45359 9.27387 6.45359 8.18946Z"
        fill="#FFC156"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.505 12.7039C9.94718 11.1801 6.76013 11.1801 4.20232 12.7039C3.47493 13.1373 3.0293 13.9215 3.0293 14.7682V18.9026C3.0293 19.1788 3.25315 19.4026 3.5293 19.4026H13.178C13.4541 19.4026 13.678 19.1788 13.678 18.9026V14.7682C13.678 13.9215 13.2324 13.1373 12.505 12.7039ZM4.71413 13.563C6.95659 12.2271 9.75071 12.2271 11.9932 13.563C12.4178 13.816 12.678 14.2739 12.678 14.7682V18.4026H4.0293V14.7682C4.0293 14.2739 4.28946 13.816 4.71413 13.563Z"
        fill="#FFC156"
      />
    </svg>
  );
}
